import { createSlice } from '@reduxjs/toolkit';

import { IAdvicesData } from 'shared/types/advices';

const initialState: IAdvicesData = {
  advices: [],
  totalCount: 0,
  link: '',
};

const advicesSlice = createSlice({
  name: 'advices',
  initialState,
  reducers: {},
  selectors: {
    selectAdvices: state => state,
  },
});

export const {
  reducer: advicesReducer,
  actions: {},
  selectors: { selectAdvices },
} = advicesSlice;
